
import Blend from "../../../assets/outline/Blend.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BlendIcon({ className, dataTestid = "BlendIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Blend data-testid={dataTestid} className={classes} {...rest} />
  );
}
